import Bullet from './Bullet';

export default Bullet;
